import { render, staticRenderFns } from "./largeFeed.vue?vue&type=template&id=46edc336&scoped=true"
import script from "./largeFeed.vue?vue&type=script&lang=js"
export * from "./largeFeed.vue?vue&type=script&lang=js"
import style0 from "./largeFeed.vue?vue&type=style&index=0&id=46edc336&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46edc336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46edc336')) {
      api.createRecord('46edc336', component.options)
    } else {
      api.reload('46edc336', component.options)
    }
    module.hot.accept("./largeFeed.vue?vue&type=template&id=46edc336&scoped=true", function () {
      api.rerender('46edc336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeFeed.vue"
export default component.exports